export default (url) => {
  window.location.replace(url);
  return false;
};
